export enum ApplicationTypeEnum {
  PURCHASE = 'PURCHASE',
  REFINANCE = 'REFINANCE',
}
